export const style = {
  spacer: {
    border: 0,
    margin: `30px 0`,
    borderTop: `1px solid #ddd`,
    borderBottom: `none`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Community/Settings/Main/style/ColorBlind/main.js